import { TIMEOUT_SEC } from './config';

const timeout = function (s) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      reject(new Error(`Request took too long! Timeout after ${s} second`));
    }, s * 1000);
  });
};

/**
 * Performs an AJAX request (GET or POST) with a timeout feature.
 *
 * @async
 * @function AJAX
 * @param {string} url - The URL to which the request is sent.
 * @param {Object} [uploadData] - Optional data to be sent as JSON in a POST request. If not provided, a GET request is made.
 * @returns {Promise<Object>} The JSON-parsed response data from the server.
 * @throws {Error} If the request fails, times out, or the response status is not 'success'.
 *
 * @example
 * // GET request:
 * const data = await AJAX('https://api.example.com/data');
 *
 * @example
 * // POST request:
 * const newItem = { name: 'Item', price: 10 };
 * const data = await AJAX('https://api.example.com/items', newItem);
 */
export async function AJAX(url, uploadData = undefined) {
  try {
    const fetchPromise = uploadData
      ? fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(uploadData),
        })
      : fetch(url);

    const res = await Promise.race([fetchPromise, timeout(TIMEOUT_SEC)]);
    const data = await res.json();

    if (data.status !== 'success')
      throw new Error(`${data.message} (${res.status})`);

    return data;
  } catch (err) {
    throw err;
  }
}
